import { render, staticRenderFns } from "./ProjectBookingReview.vue?vue&type=template&id=4c6792f6&"
import script from "./ProjectBookingReview.vue?vue&type=script&lang=js&"
export * from "./ProjectBookingReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports